<template>
  <div
    class="mainNavigation"
    :class="{ 'active': showHeaderMobileMenu }"
    :style="{
      paddingTop: infoHeaderBanner.height && infoHeaderBanner.message ? `${infoHeaderBanner.height}px` : `0px`
    }"
  >
    <nav class="container">
      <ul class="mainNavigation__menu primary">
        <template v-for="nav, i in navigation">
          <li
            v-if="!hideWidget(nav)"
            :key="nav.link + i"
            :class="{ 'active': showSub === i }"
            @mouseover="showSub = i"
            @mouseleave="showSub = false"
          >
            <NuxtLink
              :title="nav.descr"
              :to="nav.link"
              class="dropdown-trigger"
              data-target="main-dropdown"
              @mouseover="showMenu(nav.submenu)"
              @click="closeMobileNavigation"
            >
              {{ nav.title }}
            </NuxtLink>

            <div
              v-if="nav.submenu.length"
              v-show="showSub === i"
              class="subMenu product-dropdown dropdown-content absolute z-[999]"
            >
              <div
                class="inner-wrapper row"
                :class="{ 'activeMobileSubmenu': mobileSubmenu }"
              >
                <ul class="superNav col l3 m12 s12">
                  <template v-for="sub1, i1 in nav.submenu">
                    <li
                      v-if="!hideWidget(sub1)"
                      :key="sub1.link + i1"
                      :class="{ 'active': sub1.active, 'hasSub': sub1.submenu.length }"
                      @mouseover="showSubmenu($event, nav.submenu, sub1)"
                      @click="sub1.submenu.length ? showSubmenu($event, nav.submenu, sub1) : ''"
                      @touchend="closeSubMenu"
                    >
                      <NuxtLink
                        :aria-label="sub1.descr"
                        :to="sub1.link"
                        class="hasSub"
                        @click="closeMobileNavigation"
                      >
                        {{ sub1.title }}
                      </NuxtLink>

                      <span
                        v-if="sub1.submenu.length"
                        class="arrow icon icon-right-arrow"
                      ></span>
                    </li>
                  </template>

                  <template
                    v-for="navMobile, mobileIndex in navigation"
                  >
                    <li
                      v-if="mobileIndex !== 0 && !hideWidget(navMobile)"
                      :key="navMobile.link + mobileIndex"
                      :class="{ 'active': navMobile.active, 'hasSub': navMobile.submenu.length }"
                      class="hide-on-large-only"
                      @mouseover="showSubmenu($event, nav.submenu, navMobile)"
                    >
                      <NuxtLink
                        :aria-label="navMobile.descr"
                        :to="navMobile.link"
                        @click="closeMobileNavigation"
                        @touchend="closeSubMenu"
                      >
                        {{ navMobile.title }}
                      </NuxtLink>
                    </li>
                  </template>
                </ul>

                <div class="row col l9 m12 s12 no-padding">
                  <div
                    v-if="nav.submenu.find(n => n.active === true)"
                    class="subMenu__sub row col s12 no-padding"
                  >
                    <div class="subMenu__info">
                      <strong
                        class="subMenu__info__back gray lighten-3 drop-down-close"
                        @click="mobileSubmenuBack(nav.submenu)"
                        @touchend="closeSubMenu"
                      >
                        <span class="icon icon-left-arrow"></span>
                        {{ nav.submenu.find(n => n.active === true).title }}
                      </strong>

                      <div
                        v-if="nav.submenu.find(n => n.active === true).seeAllTitle"
                        class="btn-holder"
                      >
                        <NuxtLink
                          :aria-label="nav.submenu.find(n => n.active === true).seeAllTitle"
                          :to="nav.submenu.find(n => n.active === true).link"
                          class="btn waves-effect waves-light orange"
                          @click="closeMobileNavigation"
                          @touchend="closeSubMenu"
                        >
                          {{ nav.submenu.find(n => n.active === true).seeAllTitle }}
                        </NuxtLink>
                      </div>
                    </div>

                    <ul
                      v-if="nav.submenu.find(n => n.active === true).submenu.length"
                      class="dropdown-list col l4 m12 s12"
                    >
                      <template
                        v-for="sub2, i2 in nav.submenu.find(n => n.active === true).submenu"
                      >
                        <li
                          v-if="!hideWidget(sub2)"
                          :key="sub2.link + i2"
                        >
                          <NuxtLink
                            :aria-label="sub2.descr"
                            :to="sub2.link"
                            @click="closeMobileNavigation"
                            @touchend="closeSubMenu"
                          >
                            <img
                              :alt="sub2.descr"
                              :src="sub2.icon"
                              class="icon"
                            />
                            <span class="title">
                              {{ sub2.title }}
                            </span>
                          </NuxtLink>
                        </li>
                      </template>
                      <li
                        v-if="nav.submenu.find(n => n.active === true).seeAllTitle"
                        class="btn-holder"
                      >
                        <NuxtLink
                          :aria-label="nav.submenu.find(n => n.active === true).seeAllTitle"
                          :to="nav.submenu.find(n => n.active === true).link"
                          class="btn-flat waves-effect"
                        >
                          {{ nav.submenu.find(n => n.active === true).seeAllTitle }}
                        </NuxtLink>
                      </li>
                    </ul>

                    <aside
                      v-if="nav.submenu.find(n => n.active === true).subcontent"
                      class="products featured row col l8 m12 s12 hide-on-med-and-down"
                    >
                      <figure
                        v-for="content, contentIndex in nav.submenu.find(n => n.active === true).subcontent"
                        :key="content.link + contentIndex"
                        class="col s6 left-align"
                      >
                        <NuxtLink
                          :to="content.link"
                          :aria-label="content.title"
                        >
                          <span class="label">{{ content.label ? content.label : '&nbsp;' }}</span>
                          <div class="image">
                            <nuxt-picture
                              preload
                              :img-attrs="{class: 'responsive-img', alt: content.title}"
                              :src="content.image"
                            />
                          </div>
                          <strong class="h5">{{ content.title }}</strong>
                          <p class="grey-text small">
                            {{ content.descr }}
                          </p>
                          <span class="text-link">{{ $t('discover') }}</span>
                        </NuxtLink>
                      </figure>
                    </aside>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </template>
      </ul>
    </nav>
  </div>
</template>

<script setup>
const { confNavigation } = useConfig()
const { infoHeaderBanner, showHeaderMobileMenu, isNotOverflow, isShowOverlay } = useHelpers()
const { hideWidget } = useWidgets()

const mobileSubmenu = ref(false)
const showSub = ref(false)

const navigation = ref(null)
navigation.value = confNavigation.header

/**
* Show Menu
*/
const showMenu = (menu) => {
  if (!menu.length) {
    return false
  }

  menu.forEach((item) => {
    item.active = false
  })
  menu[0].active = true
}

/**
* Show Submenu
*/
const showSubmenu = (event, menu, currentItem) => {
  if (!menu.length) {
    return false
  }

  if (window.innerWidth > 992) {
    menu.forEach((item) => {
      item.active = false
    })
    currentItem.active = true
  } else if (event.type === 'click') {
    event.preventDefault()
    menu.forEach((item) => {
      item.active = false
    })
    currentItem.active = true
    mobileSubmenu.value = true
  }
}

/**
* Mobile Submenu Back
*/
const mobileSubmenuBack = (menu) => {
  menu.forEach((item) => {
    item.active = false
  })
  mobileSubmenu.value = false
}

/**
* Close Menu
*/
const closeMobileNavigation = () => {
  showSub.value = showHeaderMobileMenu.value = isNotOverflow.value = isShowOverlay.value = false
}

/**
* Close SubMenu on touch screen event
*/
const closeSubMenu = () => {
  setTimeout(() => {
    showSub.value = false
  }, 100)
}

/**
* If change hide mobile menu - hide submenu
*/
watch(showHeaderMobileMenu, (showHeaderMobileMenuNew) => {
  setTimeout(() => {
    if (!showHeaderMobileMenuNew) {
      mobileSubmenu.value = false
    }
  }, 200)
}, { deep: true })
</script>

<style lang="scss" scoped>
.mainNavigation {
  width: 100%;
  background-color: #fff;
  &__menu {
    position: relative;
    display: flex;
    margin: 0;
    & > li {
      margin-right: 2rem;
      text-align: center;
      & > a {
        position: relative;
        display: block;
        width: 100%;
        height: 100%;
        color: #015287;
        font-weight: 500;
        line-height: 3.5rem;
        transition: color .3s ease-in-out 0s,border .3s ease-in-out 0s,background .3s ease-in-out 0s,opacity .3s ease-in-out 0s,box-shadow .3s ease-in-out 0s,-webkit-box-shadow .3s ease-in-out 0s;

        &:after {
          content: "";
          position: absolute;
          top: 0;
          right: 50%;
          left: 50%;
          height: 3px;
          background-color: #09f;
          transition: opacity .3s ease-in-out 0s,left .3s ease-in-out 0s,right .3s ease-in-out 0s;
          opacity: 0;
        }
      }
      &.active {
        & > a {
          color: #09f;
          background-color: transparent !important;
          &:after {
            right: 0;
            left: 0;
            opacity: 1;
          }
        }
      }

      .subMenu {
        top: 100%;
        left: 50%;
        display: block;
        width: calc(100% + 2rem);
        max-height: inherit;
        background-color: #fff !important;
        box-shadow: 0 8px 24px 3px rgb(0 46 76 / 5%);
        border-radius: 0 0 3px 3px;
        transform: translateX(-50%) !important;
        transform-origin: top center !important;
        opacity: 1;
        &__info {
          display: none;
        }
        .superNav {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          padding: 11px 0 0;
          li {
            display: flex;
            width: 100%;
            line-height: 3.75rem;
            text-align: left;
            &:hover,
            &.active {
              background-color: transparent;
            }
            a {
              position: relative;
              width: 100%;
              height: 3.75rem;
              padding: 0 1rem;
              color: #015287;
              font-size: 1rem;
              font-weight: 500;
              line-height: inherit;
              text-align: left;
              &:hover {
                color: #09f;
                background: #fff;
              }
            }
            &.hasSub {
              position: relative;
              .arrow {
                position: absolute;
                top: 50%;
                right: 0;
                right: 20px;
                z-index: 0;
                width: 30px;
                color: #09f;
                font-size: 21px;
                transform: translateY(-50%);
                cursor: pointer;
              }
            }
            &.active {
              a {
                color: #09f;
                background: #fff;
              }
            }
          }
        }

        &__sub {
          display: flex;
          align-items: flex-start;
          & > ul {
            height: 100%;
            padding: 0;
            border-right: 1px solid #eaedf0;
            & > li {
              display: flex;
              width: 100%;
              line-height: 3.75rem;
              text-align: left;
              cursor: pointer;
              & > a {
                position: relative;
                display: flex;
                align-items: center;
                width: 100%;
                height: 3.75rem;
                padding: 0 1rem;
                color: #015287;
                font-size: 1rem;
                font-weight: 500;
                line-height: inherit;
                &:hover {
                  color: #09f;
                  background-color: #f6f7f9;
                }
                .title {
                  color: #015287;
                  font-size: 1rem;
                  font-weight: 500;
                }
                .icon {
                  width: 2rem;
                  margin: 0 1rem 0 0;
                }
              }

              &.btn-holder {
                padding: .5rem 1rem;
                .btn-flat {
                  justify-content: center;
                  height: auto;
                  margin: 0;
                  font-size: 1rem;
                  font-weight: 500;
                  line-height: 3rem;
                }
                &:hover {
                  background: transparent;
                }
              }
            }
          }

          .products {
            padding: 11px 0 1.75rem;
            figure {
              margin: 0;
            }
            .label {
              margin: 1.25rem 0 2rem;
              color: #015287;
              font-weight: 600;
            }
            .image {
              position: relative;
              display: block;
              align-self: flex-end;
              overflow: hidden;
              height: 0;
              padding-bottom: 62.5%;
              margin-bottom: 1.5rem;
              background-color: #f6f7f9;
              border-radius: 3px;;
              &:deep(img) {
                width: 100%;
              }
            }
            strong,
            p {
              margin-bottom: 1.5rem;
              line-height: 1.5;
            }
            .text-link {
              font-size: 11px;
              font-weight: 600;
              letter-spacing: .6px !important;
              text-transform: uppercase;
            }
            a {
              &:hover {
                background: transparent;
                .text-link {
                  border-bottom-color: #09f;
                }
              }
            }
          }
        }
      }
    }

    a {
      font-weight: 500;
      transition: color .3s ease-in-out 0s,border .3s ease-in-out 0s,background .3s ease-in-out 0s,opacity .3s ease-in-out 0s,box-shadow .3s ease-in-out 0s,-webkit-box-shadow .3s ease-in-out 0s;
    }
  }

  @media only screen and (min-width: 992px) {
    padding-top: 0!important;
  }

  /**
  * For Mobile Sidebar
  */
  @media only screen and (max-width: 992px) {
    position: fixed;
    top: 70px;
    left: 0;
    z-index: 1002;
    display: block !important;
    width: 100%;
    max-width: 420px;
    height: 100vh;
    padding: 0;
    transform: translateX(-105%);
    transition: .3s ease-in-out;
    will-change: transform;
    &.active {
      transform: translateX(0%);
      & > .container {
        padding: 0 0;
      }
    }
    &__menu {
      & > li {
        &:not(:first-child) {
          display: none;
        }
        &:first-child {
          & > a {
            display: none;
          }
          .subMenu {
            display: block!important;
            width: 100%;
            height: calc(100vh - 60px);
            box-shadow: none;
            opacity: 1;
            &__sub {
              display: none;
            }
            .superNav {
              height: calc(100vh - 73px);
              background-color: #fcfdfd;
              li {
                border-bottom: 1px solid #eaedf0;
                &:hover {
                  color: #09f;
                  background: #eef1f7;
                }
                &.active {
                  color: #015287;
                  background-color: #f6f7f9;
                  a {
                    color: #015287;
                    background-color: #f6f7f9;
                  }
                }
                a {
                  padding: 0 1rem;
                  &:hover {
                    color: #09f;
                    background: #eef1f7;
                  }
                }
              }
            }
            &__sub {
              ul {
                li {
                  border-bottom: 1px solid #eaedf0;
                }
              }
            }
          }
        }
      }
      .activeMobileSubmenu {
        .superNav {
          display: none!important;
        }
        .subMenu {
          width: 100%;
          &__sub {
            display: block!important;
            .products {
              display: none;
            }
            & > ul > li.btn-holder {
              display: none;
            }
          }
          &__info {
            display: block;
            &__back {
              position: relative;
              z-index: 2;
              display: block;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 50px;
              padding: 0 1rem;
              font-size: 1rem;
              font-weight: 600;
              letter-spacing: .8333px;
              text-align: center;
              text-transform: uppercase;
              background: color("grey", "lighten-5");
              cursor: pointer;
              .icon {
                position: absolute;
                top: 50%;
                left: 1rem;
                z-index: 1;
                color: #09f;
                font-size: 1.25rem;
                transform: translateY(-50%);
              }
            }
            .btn-holder {
              padding: 1rem 1rem 0 1rem;
              .btn {
                width: 100%;
              }
            }
          }
        }
      }
    }
  }

  @media only screen and (max-width: 768px) {
    top: 70px;
  }
}
</style>
